import { img } from "./helpers";

const oneDayAestheticHighlights = [
  {
    key: "scenic",
    icon: "spot",
    label: {
      JP: "絶景巡り",
      EN: "Scenic Spots",
      中文: "绝景巡游",
      한국어: "절경 투어",
    },
  },
  {
    key: "camera",
    icon: "camera",
    label: {
      JP: "一眼カメラ撮影",
      EN: "Professional Camera Shooting",
      中文: "专业相机拍摄",
      한국어: "전문 카메라 촬영",
    },
  },
  {
    key: "drone",
    icon: "drone",
    label: {
      JP: "ドローン撮影",
      EN: "Drone Shooting",
      中文: "无人机拍摄",
      한국어: "드론 촬영",
    },
  },
  {
    key: "private",
    icon: "private",
    label: {
      JP: "プライベートツアー",
      EN: "Private Tour",
      中文: "私人定制行程",
      한국어: "프라이빗 투어",
    },
  },
  {
    key: "option",
    icon: "option",
    label: {
      JP: "体験オプション追加可能",
      EN: "Optional Experiences Available",
      中文: "可追加体验项目",
      한국어: "체험 옵션 추가 가능",
    },
  },
  {
    key: "schedule",
    icon: "schedule",
    label: {
      JP: "スケジュール相談可能",
      EN: "Flexible Schedule",
      中文: "可商量行程安排",
      한국어: "일정 상담 가능",
    },
  },
];

export const oneDayAestheticTour = {
  id: "oneDayAesthetic",
  slug: "one-day-photogenic-tour",
  href: "/tours/one-day-photogenic-tour",

  categoryKey: "general",

  images: [
    img("v1784945639/DSC00440-2_syxyio.webp"),
    img("v1785311449/DSC00588-2_x2m1d1.webp"),
    img("v1785311757/IMG_8564_jkfm7r.webp"),
  ],

  tags: ["drone", "camera", "pickup", "private", "secret", "starry"],
  time: "3h",

  salePrice: {
    amount: 25000,
    unit: "group",
  },

  detail: {
    heroImage: img("v1783928240/DJI_20260707115904_0007_D_cui3oa.webp"),
    heroYoutubeUrl: "https://www.youtube.com/watch?v=MQA5nq0PXlA",
    videoId: "",
    isVertical: false,
    showCustomize: true,

    images: [
      img("v1785311449/DSC00588-2_x2m1d1.webp"),
      img("v1785776522/DSC00817_ag3z9t.webp"),
      img("v1785311757/IMG_8564_jkfm7r.webp"),
      img("v1783928240/DJI_20260707115904_0007_D_cui3oa.webp"),
      img("v1785776522/DJI_20260802131800_0033_D_drlb1i.webp"),
      img("v1784940531/DSC00400_ftuhtb.jpg"),
      img("v1785005393/DSC00191_small_lhfvnk.jpg"),
      img("v1785005395/DSC00157_small_rnomp6.jpg"),
      img("v1785776522/DSC00843_co2jqa.webp"),
      img("v1785005394/DSC00161_small_f5qnkn.jpg"),
      img("v1784266410/DJI_20260714133703_0069_D_cp1tbk.webp"),
      img("v1784189987/image4_gbt8eh.webp"),
      img("v1785776523/DSC00815_yry3re.webp"),
      img("v1784190105/DSC00269_hmidsf.jpg"),
      img("v1783930567/DSC00215_gpomzw.webp"),
      img("v1784190360/image6_ya4nkg.webp"),
      img("v1784190790/image7_h9rafx.webp"),
      img("v1785006837/DJI_20260723115724_0009_D_small_mtcpab.jpg"),
      img("v1785006839/DJI_20260723120636_0026_D_small_bgbdwa.jpg"),
      img("v1785006860/DSC00357_small_vatizy.jpg"),
      img("v1785006863/DSC00366_small_kamfi4.jpg"),
      img("v1785006867/DSC00487_small_wfsynz.jpg"),
    ],
  },

  detailTexts: {
    JP: {
      title: "SCENIC PHOTO TOUR",
      pathTitle: "秘境フォトツアー",

      heroTitle: "【1組限定】秘境フォトツアー",
      heroDescription:
        "宮古島の絶景・秘境スポットを約3時間で巡る、写真・動画撮影付きのプライベートツアー",

      time: "3時間",
      startTimes: ["10:00頃"],
      people: "1-4名様",

      heroPrice: "¥25,000",
      heroPriceNote: "税込 / 1グループ",

      description:
        "宮古島の秘境やプライベートビーチを約3時間で巡り、写真・動画・ドローン映像で旅の思い出を最高の形で残すプライベートツアーです。\n観光マップに載っていないようなローカルスポットまで、その日の天候や海況に合わせて最適な場所へご案内します。",
      featureIntro:
        "観光客が行かない秘境スポットやプライベートビーチをご案内し、宮古島で一番綺麗な海へお連れします。SNSに載せたい写真・動画は、すべてこのツアーで撮れます。",

      highlights: oneDayAestheticHighlights,

      detailItems: [
        ["催行日", "10:00頃"],
        ["所要時間", "約3時間"],
        ["料金", "¥25,000(税込) / 1グループ"],
        ["発着地", "宮古島内どこでも送迎"],
        ["最少催行人数", "1名"],
        ["最大定員", "6名(※5名様以上の場合、1名追加につき+¥20,000)"],
        ["年齢制限", "20歳〜40歳"],
      ],

      included: [
        "宮古島内どこでも送迎",
        "一眼カメラ撮影",
        "ドローン撮影",
        "写真・映像データ",
        "冷えたドリンクをご用意しています",
        "撮影スポット案内",
        "宮古島ローカル情報",
      ],

      notIncluded: ["食費", "個人的なお買い物"],

      price: {
        title: "Price",
        subtitle: "料金",
        list: [
          {
            priceTitle: "秘境フォトツアー",
            price: "¥25,000",
            priceDescription:
              "1グループの基本料金です。SUP、シュノーケル、カフェ巡りなどの体験を追加する場合は、選択内容により料金が変動します。",
          },
        ],
      },

      scheduleItems: [
        {
          time: "10:00",
          description: "集合・当日の撮影内容を確認",
          img: [],
          fullWidth: false,
        },
        {
          time: "10:30",
          description: "宮古島の絶景スポットで写真・動画撮影",
          img: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
          fullWidth: true,
        },
        {
          time: "11:30",
          description: "秘境スポットや追加の撮影スポットへ移動",
          img: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
          fullWidth: true,
        },
        {
          time: "12:30",
          description: "写真・映像データのお渡し準備",
          img: [img("v1782541275/06_euvqzf.jpg")],
          fullWidth: true,
        },
        {
          time: "13:00",
          description: "終了・解散",
          img: [img("v1782541813/4-2_yheq0r.jpg")],
          fullWidth: false,
        },
      ],
    },

    EN: {
      title: "SCENIC PHOTO TOUR",
      pathTitle: "Scenic Photo Tour",

      heroTitle: "Private Scenic Photo Tour",
      heroDescription:
        "A photo-focused private tour to hidden spots for social-media-ready photos and videos.",

      time: "3 hours",
      startTimes: ["Around 10:00"],
      people: "1-4 guests",

      heroPrice: "¥25,000",
      heroPriceNote: "Tax included / per group",

      description:
        "A private photo and video tour taking you around hidden beaches and photogenic local spots in Miyakojima in about 3 hours.\nWe guide you to places that are hard to find on ordinary tourist maps, choosing the best locations depending on the weather and ocean conditions.",
      featureIntro:
        "We guide you to hidden spots and private beaches that most tourists never visit, taking you to some of the clearest ocean in Miyakojima. This tour is where you can capture photos and videos you will want to share.",

      highlights: oneDayAestheticHighlights,

      detailItems: [
        ["Start time", "Around 10:00"],
        ["Duration", "Approx. 3 hours"],
        ["Price", "¥25,000 tax included / group"],
        ["Pickup", "Available anywhere in Miyakojima"],
        ["Minimum guests", "1 guest"],
        ["Maximum guests", "4 guests"],
        ["Age limit", "20-40 years old"],
      ],

      included: [
        "Pickup and drop-off in Miyakojima",
        "Professional camera shooting",
        "Drone shooting",
        "Photo data",
        "Short video materials",
        "Location guidance",
        "Schedule planning",
        "Local Miyakojima information",
      ],

      notIncluded: [
        "Meals",
        "Additional activity fees",
        "Personal expenses",
        "Swimwear and change of clothes",
      ],

      price: {
        title: "Price",
        subtitle: "Pricing",
        list: [
          {
            priceTitle: "Scenic Photo Tour",
            price: "¥25,000",
            priceDescription:
              "Base price per group for the 3-hour scenic photo tour.",
          },
        ],
      },

      scheduleItems: [
        {
          time: "10:00",
          description: "Meet up and confirm the shooting plan for the day",
          img: [],
          fullWidth: false,
        },
        {
          time: "10:30",
          description: "Photo and video shooting at scenic spots in Miyakojima",
          img: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
          fullWidth: true,
        },
        {
          time: "11:30",
          description: "Move to a hidden or additional scenic shooting spot",
          img: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
          fullWidth: true,
        },
        {
          time: "12:30",
          description: "Prepare photo and video data transfer",
          img: [img("v1782541275/06_euvqzf.jpg")],
          fullWidth: true,
        },
        {
          time: "13:00",
          description: "Tour ends",
          img: [img("v1782541813/4-2_yheq0r.jpg")],
          fullWidth: false,
        },
      ],
    },

    中文: {
      title: "SCENIC PHOTO TOUR",
      pathTitle: "绝景拍摄之旅",

      heroTitle: "【仅限1组】宫古岛绝景之旅",
      heroDescription:
        "前往旅游地图上不常出现的秘境，留下适合SNS分享的照片与影片。",

      time: "3小时",
      startTimes: ["约10:00"],
      people: "1-4人",

      heroPrice: "¥25,000",
      heroPriceNote: "含税 / 每组",

      description:
        "这是一项约3小时的私人拍摄之旅，将带你前往宫古岛秘境海滩和适合拍照的本地地点。\n我们会根据当天的天气和海况，选择普通旅游地图上不容易发现的地点。",
      featureIntro:
        "带你前往普通游客很少到访的秘境与私人海滩，欣赏宫古岛最清澈美丽的大海。想分享到社交平台的照片和影片，都可以在这个行程中拍到。",

      highlights: oneDayAestheticHighlights,

      detailItems: [
        ["开始时间", "约10:00"],
        ["所需时间", "约3小时"],
        ["价格", "¥25,000 含税 / 每组"],
        ["接送地点", "宫古岛内可接送"],
        ["最少成团人数", "1人"],
        ["最多人数", "4人"],
        ["年龄限制", "20岁〜40岁"],
      ],

      included: [
        "宫古岛内接送",
        "专业相机拍摄",
        "无人机拍摄",
        "照片数据",
        "短视频素材",
        "拍摄地点向导",
        "行程规划",
        "宫古岛本地信息",
      ],

      notIncluded: ["餐费", "追加体验费用", "个人消费", "泳衣及替换衣物"],

      price: {
        title: "Price",
        subtitle: "价格",
        list: [
          {
            priceTitle: "绝景拍摄之旅",
            price: "¥25,000",
            priceDescription: "这是约3小时绝景拍摄之旅的每组基本价格。",
          },
        ],
      },

      scheduleItems: [
        {
          time: "10:00",
          description: "集合并确认当天的拍摄内容",
          img: [],
          fullWidth: false,
        },
        {
          time: "10:30",
          description: "在宫古岛绝景地点进行照片和视频拍摄",
          img: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
          fullWidth: true,
        },
        {
          time: "11:30",
          description: "前往隐藏景点或追加拍摄地点",
          img: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
          fullWidth: true,
        },
        {
          time: "12:30",
          description: "准备交付照片和视频数据",
          img: [img("v1782541275/06_euvqzf.jpg")],
          fullWidth: true,
        },
        {
          time: "13:00",
          description: "行程结束・解散",
          img: [img("v1782541813/4-2_yheq0r.jpg")],
          fullWidth: false,
        },
      ],
    },

    한국어: {
      title: "SCENIC PHOTO TOUR",
      pathTitle: "절경 촬영 투어",

      heroTitle: "【1팀 한정】미야코지마 절경 투어",
      heroDescription:
        "관광 지도에 잘 나오지 않는 비경에서 SNS에 올리고 싶은 사진과 영상을 남기는 촬영 특화 투어입니다.",

      time: "3시간",
      startTimes: ["10:00경"],
      people: "1-4명",

      heroPrice: "¥25,000",
      heroPriceNote: "세금 포함 / 1그룹",

      description:
        "미야코지마의 숨은 해변과 포토제닉한 로컬 스팟을 약 3시간 동안 둘러보며 사진, 영상, 드론으로 여행의 추억을 남기는 프라이빗 투어입니다.\n당일 날씨와 바다 상황에 맞춰 관광 지도에서 찾기 어려운 장소로 안내합니다.",
      featureIntro:
        "관광객이 잘 가지 않는 숨은 명소와 프라이빗 비치로 안내하며, 미야코지마에서 가장 아름다운 바다를 보여드립니다. SNS에 올리고 싶은 사진과 영상은 이 투어에서 모두 남길 수 있습니다.",

      highlights: oneDayAestheticHighlights,

      detailItems: [
        ["시작 시간", "10:00경"],
        ["소요 시간", "약 3시간"],
        ["요금", "¥25,000 세금 포함 / 1그룹"],
        ["픽업 장소", "미야코지마 내 어디든 송영 가능"],
        ["최소 인원", "1명"],
        ["최대 인원", "4명"],
        ["연령 제한", "20세〜40세"],
      ],

      included: [
        "미야코지마 내 픽업 및 드롭오프",
        "전문 카메라 촬영",
        "드론 촬영",
        "사진 데이터",
        "짧은 영상 소재",
        "촬영 스팟 안내",
        "일정 플래닝",
        "미야코지마 로컬 정보",
      ],

      notIncluded: [
        "식사비",
        "추가 체험 비용",
        "개인 경비",
        "수영복 및 갈아입을 옷",
      ],

      price: {
        title: "Price",
        subtitle: "요금",
        list: [
          {
            priceTitle: "절경 촬영 투어",
            price: "¥25,000",
            priceDescription:
              "약 3시간 절경 촬영 투어의 1그룹 기준 기본 요금입니다.",
          },
        ],
      },

      scheduleItems: [
        {
          time: "10:00",
          description: "집합 및 당일 촬영 내용 확인",
          img: [],
          fullWidth: false,
        },
        {
          time: "10:30",
          description: "미야코지마 절경 스팟에서 사진・영상 촬영",
          img: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
          fullWidth: true,
        },
        {
          time: "11:30",
          description: "숨은 명소 또는 추가 촬영 스팟으로 이동",
          img: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
          fullWidth: true,
        },
        {
          time: "12:30",
          description: "사진・영상 데이터 전달 준비",
          img: [img("v1782541275/06_euvqzf.jpg")],
          fullWidth: true,
        },
        {
          time: "13:00",
          description: "투어 종료・해산",
          img: [img("v1782541813/4-2_yheq0r.jpg")],
          fullWidth: false,
        },
      ],
    },
  },

  texts: {
    JP: {
      title: "【1組限定】秘境フォトツアー",
      startTimes: ["10:00頃"],
      people: "1-4名様",
      notes:
        "約3時間秘境や撮影スポットを巡り、写真・動画を撮り放題(枚数制限なし)\n※5名様以上の場合、1名追加につき+¥20,000",
    },
    EN: {
      title: "Private Scenic Photo Tour",
      startTimes: ["Around 10:00"],
      people: "1-4 guests",
      notes:
        "A 3-hour scenic photo and video tour around hidden and beautiful Miyakojima spots\n※For groups of 4 or more, +¥20,000 per additional guest.",
    },
    中文: {
      title: "【仅限1组】绝景拍摄之旅",
      startTimes: ["约10:00"],
      people: "1-4人",
      notes:
        "约3小时巡游宫古岛秘境和绝美拍摄地点，留下照片与视频\n※4人以上时，每增加1人另加 ¥20,000。",
    },
    한국어: {
      title: "【1팀 한정】절경 촬영 투어",
      startTimes: ["10:00경"],
      people: "1-4명",
      notes:
        "약 3시간 동안 숨은 명소와 촬영 스팟을 돌며 사진과 영상을 남깁니다\n※4명 이상일 경우, 1명 추가당 +¥20,000입니다.",
    },
  },
};
